


















































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import * as RouteNames from "@/employee/route-names";
import { useNotifierStore } from "@/shared/store/notifier";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class PreenrollmentManagement extends Vue {
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;
  isSubmitting = false;

  notifierStore = useNotifierStore();

  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();

  drivewealthStore = useDrivewealthStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();
  signingDocumentStore = useSigningDocumentStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Watch("$props", { deep: true })
  load () {
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({});
    this.drivewealthWizardStore.loadExistingPreenrollment({ username: this.username, partnerId: this.partnerId });
    this.drivewealthSweepStore.getSweep({ username: this.username, partnerId: this.partnerId });
    this.loadSignedDocumentKey();
  }

  @Watch("investmentDailyBalanceStore.hasEnoughToOpenAccount")
  autoEnroll () {
    if (this.investmentDailyBalanceStore.hasEnoughToOpenAccount && !this.drivewealthStore.isEnrollingNow) {
      this.drivewealthStore.enrollNow()
          .then(() => {
            this.notifierStore.setSuccess("Your investment account has been created");
          })
          .catch(_ => {
            // will fail transparently
          });
    }
  }

  mounted () {
    this.load();
    this.autoEnroll();
  }

  get isLoaded () {
    return this.drivewealthWizardStore.isEnrollmentLoaded
        && this.drivewealthSweepStore.sweepLoaded
        && this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded;
  }

  get accountTypeTitle (): string {
    return "You have Enrolled for the " + this.accountType;
  }

  get accountType (): string {
    return this.drivewealthStore.getAccountManagementTypeTitle(this.drivewealthWizardStore.enrollmentAccountType);
  }

  @Watch("this.drivewealthWizardStore.enrollmentAccountType")
  loadSignedDocumentKey () {
    this.signingDocumentStore.getSignedDocumentKey(this.drivewealthWizardStore.enrollmentAccountType);
  }

  onDeleteEnrollment () {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.drivewealthWizardStore.deleteExistingPreenrollment()
          .then(() => {
            this.notifierStore.setSuccess("Investment Enrollment has been cancelled");
            this.riskToleranceQuestionnaireStore.clearStoredResults();
            this.riskToleranceQuestionnaireStore.setFetchState(FetchState.Uninitialized);
          })
          .finally(() => this.isSubmitting = false);
    }
  }
}
